import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
const CardWrapper = styled(Box)(({
  theme
}) => ({
  backgroundColor: theme.colors.surface.primary,
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  gap: theme.sizes.spacing["06"],
  alignSelf: "stretch",
  height: "100%",
  width: "100%",
  "&:not(.grouped)": {
    borderRadius: theme.sizes.radius.xl,
    overflow: "clip",
    boxShadow: "0px 1px 3px 0px rgba(36, 5, 5, 0.1)"
  },
  ".grouped &": {
    borderRadius: 0,
    padding: 0,
    boxShadow: "none"
  },
  "&.text-block": {
    flex: "1 0 0",
    width: "100%"
  },
  "&.table-6, &.table-half": {
    ".grouped &": {
      with: "fit-content"
    }
  }
}));
const Card = (t0) => {
  const $ = c(3);
  const {
    children,
    className: t1
  } = t0;
  const className = t1 === void 0 ? "" : t1;
  let t2;
  if ($[0] !== children || $[1] !== className) {
    t2 = /* @__PURE__ */ jsx(CardWrapper, { className, children });
    $[0] = children;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export {
  Card as default
};
